import { useServiceProxy } from 'hooks/kong'
import { useVehicleLocation } from 'hooks/redux/useLocations'
import { useEffect, useState } from 'react'
import { IncomingDynamoEvents } from 'types/api'

export interface ProviderCount {
  aaa: number
  uly: number
  allstate: number
}

const initialCounts: ProviderCount = { aaa: 0, uly: 0, allstate: 0 }

export const useGetProviderCounts = () => {
  //get last 100 events filtered by state
  const serviceProxy = useServiceProxy()
  const vehicleLocation = useVehicleLocation()
  const vehicleState = vehicleLocation?.address.state
  const [providerCount, setProviderCount] = useState<ProviderCount>(initialCounts)
  const [providersLoading, setProvidersLoading] = useState<boolean>(false)
  const [error, setError] = useState<null | any>(null)
  useEffect(() => {
    const fetchEvents = async () => {
      if (!providersLoading && providerCount === initialCounts) {
        setProvidersLoading(true)
        try {
          const { data } = await serviceProxy<IncomingDynamoEvents>(
            'get',
            `/serviceproxy/events-table/itemsByVehicleState?vehicleState=${vehicleState}`,
          )
          // tally up the providers
          if (data && data.Items) {
            // to prevent divide by zero issues later on, initialize counts at 1
            let counts = { aaa: 1, uly: 1, allstate: 1 }
            data.Items.forEach((item: any) => {
              // const itemProvider = item.provider ?? item.attributes?.provider.toLowerCase() ?? null
              const itemProvider = item.provider
              if (itemProvider && counts[itemProvider] !== undefined) {
                counts[itemProvider]++
              }
            })
            setProviderCount(counts)
            console.log('Provider count: ', JSON.stringify(counts))
            setProvidersLoading(false)
          }
        } catch (err) {
          setError(err)
          setProvidersLoading(false)
        }
      }
    }
    fetchEvents()
  }, [providerCount, providersLoading])

  return { providerCount, providersLoading, error }
}
